// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type StoreActionApi,
	createContainer,
	createStore,
	createActionsHook,
} from '@atlassian/react-sweet-state';

type State = Record<never, never>;

type Props = {
	embedded?: boolean;
	isSharedView?: boolean;
	isCollectionView?: boolean;
};

const initialState: State = {};

const actions = {
	/**
	 * this action has no side effects. It is a helper accessor to get the container
	 * props in through the hook API and forwarded to the reselect selectors and hooks
	 */
	getContainerProps: () => (ops: StoreActionApi<State>, props: Props) => props,
};

export const PolarisEnvironmentStore = createStore({
	initialState,
	actions,
	name: 'PolarisEnvironmentStore',
});

export const PolarisEnvironmentContainer = createContainer<State, typeof actions, Props>(
	PolarisEnvironmentStore,
);

const useActions = createActionsHook(PolarisEnvironmentStore);

const useProps = (): Props => {
	const { getContainerProps } = useActions();
	return getContainerProps();
};

// TODO: delete when cleaning up jpd_extract-environment-store
/**
 * @deprecated use useIsEmbedded from `@atlassian/jira-polaris-component-environment` package instead:
 * `const isEmbedded = fg('jpd_extract-environment-store') ? useIsEmbedded() : useIsEmbeddedOld()`
 */
export const useIsEmbedded = (): boolean => {
	const { embedded } = useProps();
	return embedded === true;
};

// TODO: delete when cleaning up jpd_extract-environment-store
/**
 * @deprecated use useIsSharedView from `@atlassian/jira-polaris-component-environment` package instead:
 * `const isSharedView = fg('jpd_extract-environment-store') ? useIsSharedView() : useIsSharedViewOld()`
 */
export const useIsSharedView = (): boolean => {
	const { isSharedView } = useProps();
	return isSharedView === true;
};

// TODO: delete when cleaning up jpd_extract-environment-store
/**
 * @deprecated use useIsCollectionView from `@atlassian/jira-polaris-component-environment` package instead:
 * `const isCollectionView = fg('jpd_extract-environment-store') ? useIsCollectionView() : useIsCollectionViewOld()`
 */
export const useIsCollectionView = (): boolean => {
	const { isCollectionView } = useProps();
	return isCollectionView === true;
};
